module.exports = __webpack_public_path__ + "fonts/59fa12c0-25c9-4c0c-bd1e-32204311d86d.bc4aedc6.eot";